import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import type {DeviceElementTarget} from '../../../modules/ruleengine/types';
import TranslatedOption from '../../common/TranslatedOption';

type Props = {
	selectedElement: DeviceElementTarget | null | undefined;
	onElementSelect: (elementName: string) => void;
	availableElements: Array<DeviceElementTarget>;
	canEdit: boolean;
};

const RuleActionDatapoint = ({selectedElement, onElementSelect, availableElements, canEdit}: Props) => {
	const elementName = selectedElement ? selectedElement.name : '';

	if (availableElements && availableElements.length) {
		return (
			<select
				onChange={({target: {value}}) => onElementSelect(value)}
				value={elementName}
				disabled={!canEdit}
				data-testid="action-datapoint-select">
				{!elementName && (
					<TranslatedOption
						trans={{
							id: `ruleengine.element.select.datapoint.empty`,
							defaultValue: `Please select...`
						}}
						value=""
					/>
				)}
				{availableElements.map((element) => (
					<TranslatedOption
						trans={{
							id: element.labelId,
							defaultValue: element.defaultLabel
						}}
						value={element.name}
						key={element.name}
					/>
				))}
			</select>
		);
	} else {
		return (
			<span>
				<Trans i18nKey="ruleengine.element.select.datapoint.notavailable">
					The device currently has no pins to set
				</Trans>
			</span>
		);
	}
};

export default RuleActionDatapoint;
